import React from 'react';
import { Link } from 'react-router-dom';
import config from '../config.json';
import Compliance from "../assets/compliance.png";
import { LegalBand } from './legal/LegalPage';
import './features/features.css';
import './legal/legal.css';

const REGISTER_URL = `${config.CUSTOMER_WEBSITE_URL}/register`;

function Check() {
    return (
        <svg width="28" height="28" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect width="35" height="33" rx="10" fill="#fde4d3" />
            <path d="M25 11L14 22L9 17" stroke="#c2410c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function PCIPage() {
    return (
        <main className="wqf wql">
            <LegalBand
                title="Compliance at WayaQuick"
                sub="WayaQuick keeps up with the best expectations of consistency conceivable in the locales inside which we work"
            />

            <div className="wqf-wrap wql-body">
                <section className="wql-card wql-pci" aria-labelledby="wql-pci-title">
                    <div className="wql-pci-badge">
                        <img src={Compliance} alt="PCI Security Standards Council" decoding="async" />
                    </div>
                    <div className="wql-pci-copy">
                        <h2 id="wql-pci-title" className="wqf-h2">WayaQuick is PCI DSS Level 1 Certified.</h2>
                        <p className="wqf-body">
                            WayaQuick has been audited by an independent PCI Qualified Security Assessor (QSA) and we're PCI DSS 3.2 compliant as a Level 1 Service Provider (loosely referred to as PCI Level 1 compliance).
                        </p>
                        <p className="wqf-body">
                            This is the most noteworthy, most severe degree of affirmation conceivable in the worldwide payments industry.
                        </p>
                        <ul className="wql-checks">
                            <li>
                                <Check />
                                <span>WayaQuick on the Visa PCI DSS-certified service provider database</span>
                            </li>
                            <li>
                                <Check />
                                <span>WayaQuick on the Mastercard Payment Facilitator database (select the Middle East/Africa tab and navigate to "WayaQuick").</span>
                            </li>
                            <li>
                                <Check />
                                <span>WayaQuick possesses a Payment System Service Providers (PSSP) Commercial Licence from the Central Bank of Nigeria</span>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>

            <section className="wqf-cta" aria-labelledby="wql-pci-cta">
                <div className="wqf-wrap wqf-cta-inner">
                    <h2 id="wql-pci-cta" className="wqf-h2">Get started now to develop your business.</h2>
                    <div className="wqf-ctas">
                        <a href={REGISTER_URL} className="wqf-btn wqf-btn-primary">
                            Register now
                        </a>
                        <Link to="/get-started" className="wqf-btn wqf-btn-ghost">
                            Explore doc
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default PCIPage
